export default __webpack_public_path__ + "static/media/benefit_16.2be3587a.png";